<template>
	<div id="app">
		<div class="nav-page">
			<Header></Header>
		</div>
    <div class="pindex">
		<router-view />
  </div>
		<Footer></Footer>
	</div>
</template>
<script>
	import Header from "@/components/header.vue";
	import Footer from "@/components/footer.vue";
	export default {
		components: { Header, Footer },
		provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      screenWidth: document.body.clientWidth
    };
  },
		mounted(){
    document.dispatchEvent(new Event('render-event'));//加载完发布这个事件
  window.onresize = () => {
        return (() => {          
            window.screenWidth = document.body.clientWidth
            this.screenWidth = window.screenWidth  
            // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
            this.show= this.screenWidth<800?true:''
            this.$store.commit("phone", this.show);
        })()
    }
},
	};
</script>

<style lang="scss">
.pindex{
  min-height: 100vh;
}
.el-dialog__title{
  color: #000000;
  font-weight: bold;
}
body::-webkit-scrollbar {
display: none;
}
.el-dialog__headerbtn{
  font-size: 20px;
}
.el-dialog__headerbtn .el-dialog__close{
  color: #000000 !important;
}
/* 修改分页器点的大小 */
.swiper-pagination-bullet {
    width: 36px !important; /* 宽度 */
    height: 4px !important; /* 高度 */
    border-radius: 0 !important;
}

/* 修改分页器点之间的间距 */
.swiper-pagination-bullet:not(:last-child) {
    margin-right: 5px !important; /* 左右间距 */
}
.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
  bottom: 30px !important;
}

@keyframes fadeIn { from { opacity: 0; }
  to { opacity: 1; } }
.fadeIn { animation-duration: .8s; animation-name: fadeIn; }
	
@keyframes fadeInUp { from { opacity: 0; transform: translate3d(0, 40px, 0); }
  to { opacity: 1;transform: translate3d(0, 0, 0); } }
.fadeInUp { animation-duration: .8s; animation-name: fadeInUp; }

@keyframes fadeInDow { from { opacity: 0; transform: translate3d(0, -20px, 0); }
  to { opacity: 1;  transform: translate3d(0, 0, 0); } }
.fadeInDow { animation-duration: .8s; animation-name: fadeInDow; }



@keyframes fadeInRight { from { opacity: 0;  transform: translate3d(40px, 0, 0); }
  to { opacity: 1;  transform: translate3d(0, 0, 0); } }
.fadeInRight { animation-duration: .8s; animation-name: fadeInRight; }


@keyframes fadeInLeft { from { opacity: 0;  transform: translate3d(-40px, 0, 0); }
  to { opacity: 1; transform: translate3d(0, 0, 0); } }
.fadeInLeft { animation-duration: .8s; animation-name: fadeInLeft; }

@keyframes fadeScale {from {opacity: 1;transform: scale(1);text-shadow: 0 0  calw(5vw) rgba(white, 1);}to {opacity: 0.8;transform: scale(0.9);text-shadow: 0 0 calw(20vw) rgba(white, 0.5);}	}
	.fadeScale{transform: 0.3;animation: fadeScale .5s infinite alternate;}

   .fadeUpDown{transform: 3;animation: floatUpDownDesktop 5s infinite alternate;}
   @keyframes floatUpDownDesktop {
        0% {
            filter: drop-shadow(0 5px 15px rgba(0, 0, 0, 0.2));
            transform: translate(0%, 0%);
        }
        50% {
            filter: drop-shadow(0 25px 15px rgba(0, 0, 0, 0.2));
            transform: translate(0%, calc(-0% - 20px));
        }
        100% {
            filter: drop-shadow(0 5px 15px rgba(0, 0, 0, 0.2));
            transform: translate(0%, 0%);
        }
    }
</style>
